<ng-container *ngIf="statusDetail; else noStatusBlock">
    <div [ngStyle]="{ 'color': statusDetail.Color, 'background-color': statusDetail.Background }"
         class="status-badge">
        {{ translationPrefix + statusDetail.Name | translate }}
    </div>
</ng-container>
<ng-template #noStatusBlock>-</ng-template>
